import axios from 'axios';
import VueI18n from 'vue-i18n';

const langs = [
  'english', 'french', 'russian', 'georgian', 'arabic', 'turkish', 'macedonian'
];

const aliaces = {
  fr: 'french',
  en: 'english',
  ru: 'russian', 
  ka: 'georgian', 
  ar: 'arabic', 
  tr: 'turkish', 
  mk: 'macedonian'
}

export const checkLang = lang => {
  if (langs.includes(lang)) {
    return lang;
  }
  if (langs.includes(aliaces[lang])) {
    return aliaces[lang];
  }
  return 'english';
};export default class TranslateService {
  getTranslationData(locale) {
    return (
      axios
        .get(process.env.VUE_APP_TRANSLATE)
        .then(({ data }) => {
          return new VueI18n({
            locale: checkLang(locale),
            messages: data
          });
        })
        // eslint-disable-next-line no-console
        .catch(e => console.error(e))
    );
  }
}
